var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-dialogContainer"},[[_c('ParseForm',{ref:"basic",attrs:{"formId":_vm.formItems.basic.formId,"formParams":_vm.formItems.basic.formObj,"opCode":_vm.opCode,"funcClick":_vm.bindClickInterface}})],_c('UsersubProfileList',{ref:"profileList",attrs:{"getCheckedDatas":_vm.getCheckedList,"ne":_vm.ne}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }